/**
 * Removes a viewport meta tag if a convo created tag
 * exists
 *
 * @returns {void}
 */
export default function removeViewportMeta() {
  // eslint-disable-next-line quotes
  const meta = document.querySelector('meta[name="viewport"]');

  if (!meta || !meta.id || meta.id.indexOf("convo-meta") !== 0) {
    return;
  }

  document.head.removeChild(meta);
  return;
}
